/* globals valueStreamRenderer */
angular.module('app.leanProjects')
	.service('reportCardService', reportCardService)
	.filter('reportCardFormat', function(currencyFormatService, numberFormatService, leanFilterService) {
		return function(input, displayType, factoryNdx) {
			var out = input;
			if (!(out || out == 0)) {
				out = '';
			}
			if (out != '' && out != 'No data for period.') {
				if (displayType == 'currency') {
					var siteId = leanFilterService.getFactoryList();
					var site = globalConfig.user.authFacts[siteId];
					var currencySymbol = site && site.currencySymbol ? site.currencySymbol : undefined;
					out = currencyFormatService.get(out, currencySymbol);
				} else {
					out = numberFormatService.get(out) + (displayType === 'percentage' ? '%' : '');
				}
			}
			return out;
		};
	})
	.controller('reportCardReportCtrl', function($scope, $rootScope, $timeout, $interval, reportCardService, $filter, $compile) {
		$scope.siteLogo = globalConfig.customer.logo;
		$scope.valueStreamName = '';
		$scope.valueStreamUserName = '';
		$scope.minDate = new Date(2012, 0, 1);
		$scope.todaysDate = '';
		$scope.reportCardParameter = [];
		$scope.reportCardWeekly = [];
		$scope.reportCardMonthly = [];
		$scope.valuestreams = [];
		$scope.today = '';
		$scope.emptyWeekly = false;
		$scope.emptyMonthly = false;
		$scope.lastCellEditable = false;
		$scope.showYearMonthDropdown = false;
		$scope.weeklyLoadingComplete = false;
		$scope.monthlyLoadingComplete = false;
		var interval;
		var isMonthsLoaded = false;
		var valueStreams = {};
		var selectedYear = '';
		var selectedMonth = '';
		var selectedValueStreamNdx = '';

		$scope.openYearMonth = function() {
			jQuery('#showYearMonthDropdown').show();
		};

		$scope.open = function() {
			$timeout(function() {
				$scope.opened = true;
			});
		};

		$scope.applyYearMonth = function() {
			var loadMonthly = true;
			selectedYear = $scope.todaysDate.getFullYear();
			selectedMonth = $scope.todaysDate.getMonth() + 1;
			loadValueStreamReportCard(selectedValueStreamNdx, loadMonthly);
		};

		$scope.cancelYearMonth = function() {
			jQuery('#showYearMonthDropdown').hide();
		};

		$scope.updateValueStream = function(valuestream) {
			selectedValueStreamNdx = valuestream.ndx;
			setValueStreamDetails(valuestream.ndx);
			loadValueStreamReportCard(valuestream.ndx);
		};

		$scope.showEdit = function(type, index) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell;
			if (type == 'Actual') {
				cell = jQuery('#Actual' + index);
			} else if (type == 'Param') {
				cell = jQuery('#paramValue' + (index + 1));
			}
			var pos = cell.offset();

			var content = cell.text();
			var editTemplate = getTemplate(pos, index, type);
			var compiledDiv = $compile(editTemplate)($scope);
			if (type == 'Actual') {
				$scope.actualQuantity = content;
			} else if (type == 'Param') {
				$scope.valueStreamParamValue = content;
			}
			jQuery('#valueStreamReportCardReport').append(compiledDiv);
			compiledDiv.keyup(function(event) {
				var code = event.keyCode || event.which;
				if (code == 13) {
					$scope.saveEdit(index, type);
				} else if (code == 27) {
					$scope.cancelEdit();
				}
			});
			if (type == 'Param') {
				jQuery('.inlineEditDiv').outerWidth(jQuery('.inlineStatusCell').outerWidth() - 40);
			}
			jQuery('.inlineEditDiv input').focus();
			$scope.inlineActive = true;
		};

		$scope.cancelEdit = function() {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			$scope.inlineActive = false;
		};

		$scope.saveEdit = function(index, type) {
			var cell = jQuery('#' + type + index);
			var content;
			var payLoad = {};
			var url = '';
			if (type == 'Actual') {
				content = strip($scope.actualQuantity);
				if (isNaN(content)) {
					jQuery('.inlineEditDiv.textEdit').height(115);
					jQuery('#errorMsg').text('Only numeric value is allowed').removeClass('hide');
					return false;
				}
				payLoad = {
					quantity: content,
					weekNo: index,
					year: selectedYear,
					month: selectedMonth
				};
			} else if (type == 'Param') {
				content = strip($scope.valueStreamParamValue);
				var record = $scope.reportCardParameter[index];
				payLoad = {
					valuestreamNdx: selectedValueStreamNdx,
					paramNdx: record.ndx,
					paramValue: content
				};
				reportCardService.putValueStreamParam(selectedValueStreamNdx, payLoad, record.paramndx == -1 ? 'POST' : 'PUT', record.paramndx, record.dateModified).then(function(data) {
					if (data) {
						$timeout(function() {
							loadReportCardParameters(selectedValueStreamNdx);
						}, 200);
						jQuery('.inlineEditDiv').unbind();
						jQuery('.inlineEditDiv').remove();
						$scope.inlineActive = false;
					} else {
						$rootScope.$emit('toast', {'message': 'Unable to Save', 'success': false});
					}
				});
			}
		};

		function getTemplate(position, rowIndex, type) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (position.left + 296 > windowWidth) {
				position.left = position.left - (position.left + 296 - windowWidth - 8);
			}
			if (position.top + 112 > windowHeight) {
				position.top = position.top - (position.top + 112 - windowHeight - 8);
			}
			var header = (type == 'Actual') ? 'Enter Actual Quantity' : 'Add a param value';
			var scopeModal = (type == 'Actual') ? 'actualQuantity' : 'valueStreamParamValue';
			var editTemplate = '<div class="inlineEditDiv textEdit" style="top:' + position.top + 'px; left: ' +
				position.left + 'px;"><div class="inlineEditHeader">' + header + '</div>' +
				'<span id="errorMsg" style="color:red;" class="hide"></span>' +
				'<div class="input-holder-with-clear">' +
				'<input class="inlineEditInput with-clear" ng-model="' + scopeModal + '" />' +
				'<span class="input-clear" ng-show="' + scopeModal + ' && ' + scopeModal + '.length" ng-click="' + scopeModal + ' = \'\'"><i class="fa fa-times"></i></span>' +
				'</div>' +
				'<div class="inlineEditButtons"><a class="button flat" ng-click="cancelEdit()">Cancel</a>' +
				'<a class="button flat colored" ng-click="saveEdit(' + rowIndex + ', \'' + type + '\')">Save</a></div></div>';
			return editTemplate;
		}

		function updateMonthlyColumnHeader(fiscalStartMonth) {
			if ($scope.monthlyLoadingComplete) {
				angular.element(document).ready(function() {
					if (fiscalStartMonth == '') {
						fiscalStartMonth = 1;
					}
					var d = moment(new Date('2016/' + fiscalStartMonth + '/11'));
					for (var i = 1; i <= 12; i++) {
						jQuery('#monthHeader' + i).text(($filter('date')(d.toDate(), 'MMM')));
						d.add(1, 'month');
					}
				});
			} else {
				$timeout(function () {
					updateMonthlyColumnHeader(fiscalStartMonth);
				}, 100);
			}

		}

		function setWeeklyHeaders(weekNo, weekDate) {
			jQuery('#partHeader' + weekNo).text('Week ' + weekNo + weekDate);
			jQuery('#weekHeader' + weekNo).text('Week ' + weekNo + weekDate);
			jQuery('#partHeaderDetail' + weekNo).text('Week ' + weekNo + weekDate);
		}
		function updateWeeklyColumnHeader(dates) {
			angular.element(document).ready(function() {
				for (var i = 1; i < 6; i++) {
					if (dates[i - 1]) {
						setWeeklyHeaders(i, '(' + $filter('date')(dates[i - 1].weekEndDate, 'MMM d', 'UTC') + ')');
					} else {
						setWeeklyHeaders(i, '');
					}
				}
				if (dates.length == 5) {
					$scope.lastCellEditable = true;
				}
			});
		}

		function getClass(type, act, goal) {
			var goalClass = '';
			if (goal !== null) {
				// account for small discrepancies like floating point errors
				var absGoal = Math.abs(goal);
				var tinyFractionOfGoal = 0.00001;
				if (absGoal < 1) {
					tinyFractionOfGoal *= absGoal;
				}
				if (type.toLowerCase() === 'below') {
					if (act <= goal + tinyFractionOfGoal) {
						goalClass = 'greenCell';
					} else if (act <= goal + absGoal * 0.1) {
						goalClass = 'yellowCell';
					} else {
						goalClass = 'redCell';
					}
				} else {
					if (act >= goal - tinyFractionOfGoal) {
						goalClass = 'greenCell';
					} else if (act >= goal - absGoal * 0.1) {
						goalClass = 'yellowCell';
					} else {
						goalClass = 'redCell';
					}
				}
			}
			return goalClass;
		}

		$scope.getColorClass = function(dataRow, property, goalProperty) {
			if (dataRow[property] == 'No data for period.') {
				return 'disabledCell';
			} else {
				var actualValue = dataRow[property];
				if (!(dataRow[property] || dataRow[property] == 0)) {
					actualValue = '';
				};
				if (actualValue != '') {
					var targetProperty = goalProperty || 'goal';
					//  fallback to 'goal' handles weekly metrics with monthly targets
					var targetValue = dataRow[targetProperty] || dataRow['goal'];
					return getClass(dataRow['goalType'], actualValue, targetValue);
				}
				return '';
			}
		};

		$scope.getMonthlyColorClass = function(dataRow, property) {
			if (dataRow[property] == 'No data for period.') {
				return 'disabledCell';
			} else {
				var actualValue = dataRow[property] || '';
				var targetValue = dataRow[property.replace('month', 'target')] || '';
				if (actualValue != '') {
					var className = '';
					if (targetValue != null && targetValue !== '') {
						className = getClass(dataRow['goalType'], actualValue, targetValue);
					}
					return className;
				}
				return '';
			}
		};

		function loadReportCardWeeklyDates(year, month) {
			reportCardService.getReportCardWeeklyDates(year, month).then(function(data) {
				if (data) {
					updateWeeklyColumnHeader(data.weekData);
				}

				if (!isMonthsLoaded) {
					updateMonthlyColumnHeader(data.firstFiscalMonth);
				}
			});
		}

		function loadReportCardParameters(valueStreamNdx) {
			reportCardService.getReportCardParameters(valueStreamNdx).then(function(data) {
				if (data && data.length > 0) {
					$scope.reportCardParameter = data;
					$timeout(function() {
						checkForElementExistsAndCall(setDailyHeader);
					}, 10);
				}
			});
		}

		function loadReportCardWeekly(valueStreamNdx, year, month) {
			reportCardService.getReportCardWeekly(valueStreamNdx, year, month).then(function(data) {
				if (data && data.length > 0) {
					$scope.reportCardWeekly = data;
					$scope.emptyWeekly = false;
				} else {
					$scope.emptyWeekly = true;
				}
				$scope.weeklyLoadingComplete = true;
				$timeout(function() {
					setWeeklyHeader();
				}, 0);
			});
		}

		function loadReportCardMonthly(valueStreamNdx, year) {
			reportCardService.getReportCardMonthly(valueStreamNdx, year).then(function(data) {
				if (data && data.length > 0) {
					$scope.reportCardMonthly = data;
					$scope.emptyMonthly = false;
				} else {
					$scope.emptyMonthly = true;
				}
				$scope.monthlyLoadingComplete = true;
				if (!$scope.emptyMonthly) {
					$timeout(function() {
						setMonthlyHeader();
					}, 0);
				}
			});
		}

		function loadValueStreamReportCard(valueStreamNdx, loadMonthly) {
			loadReportCardParameters(valueStreamNdx);
			loadReportCardWeekly(valueStreamNdx, selectedYear, selectedMonth);
			if (typeof loadMonthly == 'undefined' || loadMonthly) {
				loadReportCardMonthly(valueStreamNdx, selectedYear);
			}
			loadReportCardWeeklyDates(selectedYear, selectedMonth);
		}

		function setDailyHeader() {
			var dailyTableHeight = jQuery('#valueStreamReportParameters').outerHeight();
			var dailySideHeader = jQuery('#valueStreamReportCardReport .daily');
			dailySideHeader.outerHeight(dailyTableHeight - 7);
			var newPadding = (dailyTableHeight - 2) / 2 - 20;
			if (newPadding >= 11) {
				dailySideHeader.css('padding-top', newPadding + 'px');
			}
		}

		function setMonthlyHeader() {
			var monthTableHeight = jQuery('#monthlyReportCard').height();
			var monthlySideHeader = jQuery('#valueStreamReportCardReport .vertical-text-container .rotated-text.monthly');
			monthlySideHeader.css('height', (monthTableHeight - 6) + 'px');
			var newPadding = (monthTableHeight - 1) / 2 - 20;
	
			if (newPadding >= 11) {
				monthlySideHeader.css('padding-top', newPadding + 'px');
			} else {
				// if newPadding is less than 11, then there will be only single row
				monthlySideHeader.css('padding-top', newPadding + 4 + 'px');
			}
		}

		function setWeeklyHeader() {
			var weekTableHeight = jQuery('#weeklyReportCard').height();
			var weeklySideHeader = jQuery('#valueStreamReportCardReport .vertical-text-container .rotated-text.weekly');
			weeklySideHeader.css('height', (weekTableHeight - 6) + 'px');
			var newPadding = (weekTableHeight - 1) / 2 - 20;

			weeklySideHeader.css('padding-top', newPadding + 'px');
		}

		function setValueStreamDetails(valueStreamNdx) {
			if (valueStreams[valueStreamNdx]) {
				$scope.valueStreamName = valueStreams[valueStreamNdx].name;
				$scope.managerName = valueStreams[valueStreamNdx].personName;
			} else {
				$scope.valueStreamName = '';
			}
		}

		function checkForElementExistsAndCall(callBackFunction) {
			var existCondition = setInterval(function() {
				 if (jQuery('#valueStreamReportCardReport').length) {
				    clearInterval(existCondition);
				    callBackFunction();
				 }
			}, 10); // check every 100ms
		}
		
		
		function init() {
			var vsNdx = $rootScope.vsNdx;
			var d = new Date();
			var qParams = parseQueryString(window.location.href);
			$scope.todaysDate = d;
			selectedYear = d.getFullYear();
			selectedMonth = d.getMonth() + 1;
			reportCardService.getValueStreams().then(function(data) {
				if (data && data.length > 0) {
					$scope.valuestreams = data;
					angular.forEach(data, function(valueStream) {
						valueStreams[valueStream.ndx] = valueStream;
					});
					setValueStreamDetails(vsNdx);
				}
			});

			if (vsNdx) {
				selectedValueStreamNdx = vsNdx;
				loadValueStreamReportCard(vsNdx);
				interval = $interval(function() {
					loadValueStreamReportCard(selectedValueStreamNdx);
				}, 300000);
			}

		}
		// Disable weekend selection

		init();

		$scope.$on('$destroy', function() {
			if (interval) {
				$interval.cancel(interval);
			}
		});
	});

function reportCardService($http, leanFilterService) {
	var urlPfx = '/api/2/factndx/{0}/ReportCard/';

	return {
		getValueStreams: getValueStreams,
		getReportCardWeeklyDates: getReportCardWeeklyDates,
		getReportCardParameters: getReportCardParameters,
		getReportCardWeekly: getReportCardWeekly,
		getReportCardMonthly: getReportCardMonthly,
		putValueStreamParam: putValueStreamParam
	};

	function getValueStreams() {
		return $http.get(
			'/api/2/factndx/' + leanFilterService.getFactoryList() + '/ReportCard/ValueStreams')
			.then(getValueStreamsComplete)
			.catch(getValueStreamsFailed);

		function getValueStreamsComplete(response) {
			return response.data;
		}

		function getValueStreamsFailed(error) {
			return error;
		}
	}

	function getReportCardWeeklyDates(year, month) {
		return $http.get(
			'/api/2/factndx/' + leanFilterService.getFactoryList() + '/Calendar/Year/' + year + '/Month/' + month)
			.then(getReportCardWeeklyDatesComplete)
			.catch(getReportCardWeeklyDatesFailed);

		function getReportCardWeeklyDatesComplete(response) {
			return response.data;
		}

		function getReportCardWeeklyDatesFailed(error) {
			return error;
		}
	}

	function getReportCardParameters(valueStreamNdx) {
		return $http.get(
			String.format(urlPfx, leanFilterService.getFactoryList()) + valueStreamNdx + '/Params')
			.then(getReportCardParametersComplete)
			.catch(getReportCardParametersFailed);

		function getReportCardParametersComplete(response) {
			return response.data;
		}

		function getReportCardParametersFailed(error) {
			return error;
		}
	}

	function getReportCardWeekly(valueStreamNdx, year, month) {
		return $http.get(
			String.format(urlPfx, leanFilterService.getFactoryList()) + valueStreamNdx + '/Metrics/Weekly/Year/' + year + '/Month/' + month)
			.then(getReportCardWeeklyComplete)
			.catch(getReportCardWeeklyFailed);

		function getReportCardWeeklyComplete(response) {
			return response.data;
		}

		function getReportCardWeeklyFailed(error) {
			return error;
		}
	}

	function getReportCardMonthly(valueStreamNdx, year, month) {
		return $http.get(
			String.format(urlPfx, leanFilterService.getFactoryList()) + valueStreamNdx + '/Metrics/Monthly/Year/' + year)
			.then(getReportCardMonthlyComplete)
			.catch(getReportCardMonthlyFailed);

		function getReportCardMonthlyComplete(response) {
			return response.data;
		}

		function getReportCardMonthlyFailed(error) {
			return error;
		}
	}

	function putValueStreamParam(valueStreamNdx, payLoad, method, paramNdx, dateModified) {
		var url = String.format(urlPfx, leanFilterService.getFactoryList()) + valueStreamNdx + '/Param';
		if (method == 'PUT') {
			url += '/' + paramNdx;
		}
		return $http({
			method: method,
			url: url,
			headers: {
				'If-Unmodified-Since': (dateModified == null || dateModified == '') ? (new Date()).toUTCString() : (new Date(dateModified)).toUTCString()
			},
			data: payLoad
		}).then(function successCallback(response) {
			return true;
		}, function errorCallback(response) {
			return false;
		});
	}
}
